(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"));
	else if(typeof define === 'function' && define.amd)
		define("node-fred", ["axios"], factory);
	else if(typeof exports === 'object')
		exports["node-fred"] = factory(require("axios"));
	else
		root["node-fred"] = factory(root["axios"]);
})(global, (__WEBPACK_EXTERNAL_MODULE__300__) => {
return 